"use client";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Icon } from "@/components/ui/icon";
import { DISTANCE_OPTIONS_KM, DISTANCE_OPTIONS_MI } from "@/features/search/lib/filter-options";

export function DistanceDropdown({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string) => void;
}) {
  const isKm = value.includes("km");
  const options = isKm ? DISTANCE_OPTIONS_KM : DISTANCE_OPTIONS_MI;

  const handleSwitchUnit = () => {
    const converted = isKm
      ? (DISTANCE_OPTIONS_MI[DISTANCE_OPTIONS_KM.indexOf(value)] ?? "15 mi")
      : (DISTANCE_OPTIONS_KM[DISTANCE_OPTIONS_MI.indexOf(value)] ?? "25 km");
    onChange(converted);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className="flex items-center gap-0.5 cursor-pointer">
          <span className="text-[11px] tracking-[-0.1px] text-ai whitespace-nowrap">
            {value}
          </span>
          <Icon name="IconChevronDownMedium" size={11} className="text-ai" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" sideOffset={2} className="w-[120px]">
        <DropdownMenuRadioGroup value={value} onValueChange={onChange}>
          {options.map((opt) => (
            <DropdownMenuRadioItem key={opt} value={opt} className="text-xs">
              <span>{opt}</span>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={handleSwitchUnit} className="text-xs text-contrast/50">
          Switch to {isKm ? "miles" : "km"}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
